import { useEffect } from 'react';

/**
 * Reports `busy` through `onBusyChange` each time it changes, and reports
 * false as the caller unmounts, so a busy flag never outlives the work that
 * raised it.
 */
export function useReportBusy(
    busy: boolean,
    onBusyChange: (busy: boolean) => void
): void {
    useEffect(() => {
        onBusyChange(busy);
        return () => onBusyChange(false);
    }, [busy, onBusyChange]);
}
